import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {AccountLink} from 'src/components/links';

import {PLACE} from '../../constants';
import {
    accountSearchResultConferenceUsersDataSelector,
    accountSearchResultConferenceUsersResultSelector,
} from '../../slices/account-search-result-conference-users.slice';

type Props = {
    accountId: number,
};

export const ConferenceUsersCell = ({accountId}: Props) => {
    const {isLoading, loadingError} = useSelector(accountSearchResultConferenceUsersDataSelector);
    const result = useSelector(accountSearchResultConferenceUsersResultSelector);

    const count = useMemo(() => result?.data[accountId], [result, accountId]);

    if (isLoading || loadingError || !count) {
        return null;
    }

    return (
        <AccountLink
            accountId={accountId}
            place={PLACE}
            accountName={count.toString()}
            target="users-groups/virtual"
        />
    );
};
